
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/airports/articles",
      function () {
        return require("private-next-pages/airports/articles.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/airports/articles"])
      });
    }
  